import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=c47fabc0&scoped=true&"
import script from "./UiCheckbox.vue?vue&type=script&lang=js&"
export * from "./UiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=c47fabc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47fabc0",
  null
  
)

export default component.exports